import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@mui/material"
import { useState } from "react"
import PasswordInput from "./PasswordInput";
import { updateAdminPassword } from "../services/auth";
import { enqueueSnackbar } from "notistack";

const AdminPasswordModal = ({
  open,
  admin_id,
  onClose
}) =>{ 

  const [password, set_password] = useState('');
  const [is_saving, set_is_saving] = useState(false);

  const handleCloseDialog = () => {
    set_password('');
    onClose()
  }

  const handleSave = async () => {

    set_is_saving(true);
    const {data} = await updateAdminPassword({
      data : {
        new_password : password,
        user_id : admin_id
      }
    });
    set_is_saving(false);

    if(data){
      enqueueSnackbar('Password updated successfully !', {
        variant : 'success'
      });
      handleCloseDialog();
    }else{
      enqueueSnackbar('Error while updating password', {
        variant : 'error'
      })
    }
  }

  return(
    <Dialog
      open = {open}
      fullWidth
      maxWidth = 'xs'
    >
      <DialogTitle>
        Update Password
      </DialogTitle>
      <Divider />
      <DialogContent>
        <PasswordInput
          fullWidth
          label = 'New Password'
          value = {password}
          onChange = {
            (e) => set_password(e.target.value)
          }
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={handleCloseDialog}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={
            is_saving ||
            !Boolean(password)
          }
          onClick={handleSave}
        >
          {
            is_saving ? 
            <CircularProgress
              size={'20px'}
              color="inherit"
            /> : 
            "Save"
          }
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AdminPasswordModal;